import {FC, useRef} from 'react';
import {CSSTransition} from 'react-transition-group';
import Cookies from 'js-cookie';
import {useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';

import {useSelector} from '~/store/hooks';
import {deviceOsName} from '~/utils/browserDetect';
import {Dispatch} from '~/store/types';

import CrossSvg from './svg/cross.svg';
import LogoSvg from './svg/logo.svg';
import s from './styles.module.scss';

// TODO: #js-gtag-click-snackbar described into gtag.js. Need to create react gtag util
const SnackBar: FC = () => {
  const dispatch = useDispatch<Dispatch>();
  const {data, isSnackbarVisible} = useSelector(({app}) => app);
  const nodeRef = useRef(null);

  const handleClose = () => {
    dispatch.app.toggleSnackBar(false);

    Cookies.set('SNACKBAR', 'hide');
  };

  return (
    <CSSTransition
      in={isSnackbarVisible}
      nodeRef={nodeRef}
      timeout={300}
      appear
      classNames={{
        appear: s['snackbar-appear'],
        appearActive: s['snackbar-appear-active'],
        exit: s['snackbar-exit'],
        exitActive: s['snackbar-exit-active'],
      }}
      unmountOnExit
    >
      <div ref={nodeRef} className={s.snackbar}>
        <div title="Hide this notification" onClick={handleClose} className={s['snackbar--close']}>
          <CrossSvg />
        </div>

        <Link
          id="js-gtag-click-snackbar"
          to={`/get-app?os=${deviceOsName()?.toLowerCase()}`}
          target="_blank"
          className={s['snackbar--link']}
          download="Application"
        >
          <div className={s['snackbar--logo']}>
            <LogoSvg />
          </div>

          <div className={s['snackbar--text']}>
            <strong>Download {data.instanceInfo.label} APK</strong>
            <span>FREE</span>
          </div>

          <div className={s['snackbar--svg']}>
            <img
              loading="lazy"
              src="/img/snackbar/android-sm.svg"
              width="45"
              height="45"
              alt="android"
            />

            <span>
              Download for <strong>Android</strong>
            </span>
          </div>
        </Link>
      </div>
    </CSSTransition>
  );
};

export default SnackBar;
